import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, firstValueFrom } from 'rxjs';
import { CountryUserService } from '../../services/countryuser.service';
import { CountryDetectionService } from 'src/app/services/countrydetection.service';

const allowedCountries = ['be', 'nl', 'at', 'fr', 'de', 'pl', 'it', 'pt', 'uk', 'es'];

@Injectable({ providedIn: 'root' })
export class CountryDetectGuard implements CanActivate {
    constructor(private countryUser: CountryUserService, private router: Router, private countryDetection: CountryDetectionService) { }

    async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
        //console.log('detected');
        const countryCode = route.params['countryCode'];
        const langCode = route.params['langCode'];
        if (!allowedCountries.includes(countryCode)) {
            try {
                let countryInfo = await this.countryDetection.detectCountry();
                //console.log('Detected country:', countryInfo);
                if (countryInfo && countryInfo.countryCode) {
                //console.log('detected', countryInfo.countryCode);
                //switch for every country of the allowedCountries
                switch (countryInfo.countryCode.toLowerCase()) {
                    case 'be':
                        return this.router.createUrlTree(['/takata', 'be', 'fr']);
                    case 'nl':
                        return this.router.createUrlTree(['/takata', 'nl', 'nl']);
                    case 'at':
                        return this.router.createUrlTree(['/takata', 'at', 'de']);
                    case 'fr':
                        return this.router.createUrlTree(['/takata', 'fr', 'fr']);
                    case 'de':
                        return this.router.createUrlTree(['/takata', 'de', 'de']);
                    case 'pl':
                        return this.router.createUrlTree(['/takata', 'pl', 'pl']);
                    case 'it':
                        return this.router.createUrlTree(['/takata', 'it', 'it']);
                    case 'pt':
                        return this.router.createUrlTree(['/takata', 'pt', 'pt']);
                    case 'uk':
                        return this.router.createUrlTree(['/takata', 'uk', 'en']);
                    case 'es':
                        return this.router.createUrlTree(['/takata', 'es', 'es']);
                    default:
                        return this.router.createUrlTree(['/takata', 'fr', 'fr']);
                }
            } else {
                //console.log('detected', "    null");
                return this.router.createUrlTree(['/takata', 'fr', 'fr']);
            }
            } catch (error) {
                //console.error('Error detecting country:', error);
                
            }
            
        }
        return true;
    }
}
